import ToastSuccess from './ToastSuccess';

export default ToastSuccess;
